import React from 'react';
import HamHeader from '../../Header/HamburgerHeader';
import cn from 'classnames';
import style from '../sensors.module.scss';
import QrScanComp from '../../Common/QrScanComp/index';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const RegisterSensor = props => {
  const {
    setPopup,
    sensorGroupsList,
    selectedStation,
    setGroup,
    group,
    setCodeValue,
    showQRSection,
    setShowQRSection,
    checkDuplicate,
  } = props;

  const validateExtractQRCode = qrLink => {
    if (qrLink?.includes('?')) {
      return qrLink?.split('=').slice(-1)[0];
    }
    return qrLink?.split('/').slice(-1)[0];
  };

  const handleQRScan = data => {
    if (data?.includes('/s/')) {
      const scanCode = validateExtractQRCode(data);
      setCodeValue(scanCode);
      if (scanCode) {
        checkDuplicate(scanCode);
        return setPopup({ type: 'Add Sensor' });
      }
    }
  };

  return (
    <div className={cn(style.RegisterSensor, 'h-100 p-3')}>
      <div className="mb-3">
        <HamHeader
          label={showQRSection ? FLABEL().HEADER_ADDSENSOR : FLABEL().HEADER_SENSORGROUP}
          onClickback={() => {
            setPopup(null);
            setGroup(null);
          }}
        />
      </div>

      <div className={cn(style.registerContainer, 'col-12 px-0')}>
        <div
          className={cn(style.Title, 'd-flex align-items-center px-1', {
            'justify-content-center': !showQRSection,
            'justify-content-start': showQRSection,
          })}
        >
          {FLABEL().TABLE_SENSOR_TABLE} {selectedStation?.name || selectedStation?.number}
        </div>

        <div
          className={cn(
            'd-flex h-92',
            !showQRSection ? 'justify-content-center' : ''
          )}
        >
          {/* LEFT SIDE - Sensor Group */}
          <div
            className={cn(
              showQRSection ? 'col-4 px-3' : 'col-8',
              style.sensorGrpsContainer
            )}
          >
            <div className="fw-500 pb-2">{FLABEL().TABLE_SENSOR_SENSOR_GROUP}</div>
            <div className={cn(style.subTitle)}>{FLABEL().TABLE_SENSOR_SELECTION}</div>
            <div
              className={cn(
                style.sensorGrpsWrapper,
                { [style.sensorGrpsWrapper_2]: showQRSection },
                'd-flex flex-column align-items-stretch col-12 px-0'
              )}
            >
              {sensorGroupsList.map(sensorGrp => (
                <div key={`SensorGrpID-${sensorGrp.id}`}>
                  <div
                    className={cn(
                      style.sensorGrpName,
                      'd-flex align-items-center justify-content-center p-3 w-100'
                    )}
                    style={{
                      border:
                        sensorGrp.id === group?.id
                          ? '2px solid var(--primary-selection-color)'
                          : '2px solid transparent',
                    }}
                    onClick={() => setGroup(sensorGrp)}
                  >
                    {sensorGrp.name}
                  </div>
                </div>
              ))}
            </div>

            {!showQRSection && (
              <div className="d-flex gap-2 pt-3">
                <div className="col-6 pl-0 pr-2">
                  <button
                    className={cn(style.Secondarybtn, 'col-12 fw-500')}
                    onClick={() => setGroup()}
                  >
                    {FLABEL().TABLE_SENSOR_CLEAR}
                  </button>
                </div>
                <div className={cn('col-6 pr-0 pl-2')}>
                  <button
                    className={cn(
                      style.primaryBtn,
                      !group && style.disabled,
                      'col-12 fw-500'
                    )}
                    onClick={() => {
                      setShowQRSection(true);
                    }}
                  >
                    {FLABEL().TABLE_SENSOR_ADDQR}
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* RIGHT SIDE - QR Section */}
          {showQRSection && (
            <div className="col-8 px-3">
              <div
                className={cn(
                  style.sensorGrpsContainer,
                  'd-flex flex-column align-items-center justify-content-center'
                )}
              >
                <div className="text-center pb-3 h-15">
                  {FLABEL().TABLE_SENSOR_FIT_BARCODE}
                </div>
                <div
                  className={cn(
                    style.qrScannerBg,
                    'col-10 p-5 d-flex flex-column align-items-center justify-content-center h-70'
                  )}
                >
                  <QrScanComp handleScan={handleQRScan} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegisterSensor;
